import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { getMockMembershipExtendedById } from 'app/src/msw/stories/common-stories-mock'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const getMembershipById = http.get<
  { membershipId: string },
  DefaultBodyType,
  membershipApi.MembershipExtended | membershipApi.ErrorEntityNotFound
>(apiBaseUrl + '/memberships/:membershipId', async ({ request, params }) => {
  const url = new URL(request.url)
  const includeFamilyMembers: boolean = JSON.parse(url.searchParams.get('includeFamilyMembers') ?? 'false')
  const includePrizeGroups: boolean = JSON.parse(url.searchParams.get('includePrizeGroups') ?? 'false')

  const { membership, welfareCampaign, familyMembers } = await getMockMembershipExtendedById(params.membershipId)

  if (!membership) {
    const responseError: membershipApi.ErrorEntityNotFound = {
      status: 404,
      title: 'Membership non trovata',
      type: 'urn:notfound',
      rc: 404,
    }
    return HttpResponse.json(responseError, { status: 404 })
  }

  // Aggiungi family members se richiesto
  if (includeFamilyMembers) {
    console.log('Aggiungo family members al mock membership')
    membership.userFamilyMembers = familyMembers || []
    membership.userFamilyMembersPrivacyTemplateURL =
      'https://companywelfaresvil.poste.it/static/documents/privacy/Modulo_consenso_al_trattamento_dei_dati_particolari_Informativa_privacy_welfare_2024_97103880585.pdf'
  }

  // Aggiungi prize groups se richiesto
  if (includePrizeGroups) {
    const companyPrize: membershipApi.PrizeGroup[] = await (await fetch('./data/membership/companyPrize.json')).json()
    membership.companyPrize = companyPrize
  }

  if (!welfareCampaign) {
    const responseError: membershipApi.ErrorEntityNotFound = {
      status: 404,
      title: 'Welfare Campaign non trovata',
      type: 'urn:notfound',
      rc: 404,
    }
    return HttpResponse.json(responseError, { status: 404 })
  }

  const baseMembership: membershipApi.MembershipExtended = {
    membershipInfo: {
      ...membership,
      userEmail: membership.userEmail ?? 'test@email.com',
    },
    welfareCampaign: welfareCampaign,
    userWelfareMode: 'fruition',
  }

  return new HttpResponse(JSON.stringify(baseMembership), {
    status: 200,
    headers: {
      'Content-Type': 'application/json',
    },
  })
})
